module.exports = __webpack_public_path__ + "img/stock3.21864a73.png";